import { useState, useEffect } from 'react';
import api from '../lib/api';

// Default images to use as fallbacks
const DEFAULT_IMAGES = {
  landing: 'https://images.unsplash.com/photo-1760234949196-99e7ea7f3b0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBicmlnaHQlMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzY2OTM1Njk4fDA&ixlib=rb-4.1.0&q=85',
  login: 'https://images.unsplash.com/photo-1758691737158-18ffa31c0a46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwYnVzaW5lc3MlMjB0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3NjY5MzU3MDB8MA&ixlib=rb-4.1.0&q=85',
  register: 'https://images.unsplash.com/photo-1622258416235-d0390821fc08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGVtcGxveWVlJTIwd29ya2luZyUyMGxhcHRvcCUyMGJyaWdodCUyMG9mZmljZXxlbnwwfHx8fDE3NjY5MzU3MDJ8MA&ixlib=rb-4.1.0&q=85'
};

export const useSystemSettings = () => {
  const [settings, setSettings] = useState({
    landingPageEnabled: true,
    landingImage: DEFAULT_IMAGES.landing,
    loginImage: DEFAULT_IMAGES.login,
    registerImage: DEFAULT_IMAGES.register,
    siteName: 'OMS Portal',
    idleTimeoutMinutes: 3
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/system/settings');
        if (response.data.success && response.data.data) {
          const data = response.data.data;
          setSettings({
            landingPageEnabled: data['frontend.landing_page_enabled'] !== false,
            landingImage: data['frontend.landing_image'] || DEFAULT_IMAGES.landing,
            loginImage: data['frontend.login_image'] || DEFAULT_IMAGES.login,
            registerImage: data['frontend.register_image'] || DEFAULT_IMAGES.register,
            siteName: data['frontend.site_name'] || 'OMS Portal',
            idleTimeoutMinutes: parseInt(data['security.idle_timeout_minutes']) || 3
          });
        }
      } catch (error) {
        console.error('Error fetching system settings:', error);
        // Use defaults on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};

export default useSystemSettings;
